import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout/auth-layout.component';
import { WizardLayoutComponent } from './layout/wizard-layout/wizard-layout.component';
import { AuthGuard } from './guards/auth.guard';
import { storeResolver } from './shared/state/store/store-resolvers';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
};

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard], // Protect this route with the AuthGuard
    children: [
      {
        path: '',
        loadChildren: () => import('./features/home/home.module').then((m) => m.HomePageModule),
      },
      {
        path: 'home',
        data: { breadcrumb: 'UI Kit' },
        loadChildren: () => import('./demo/components/uikit/uikit.module').then((m) => m.UIkitModule),
      },
      {
        path: 'company',
        data: { breadcrumb: 'Εταιρεία' },
        loadChildren: () => import('./features/company-management/company-management.module').then((m) => m.CompanyManagementModule),
      },
      {
        path: 'inventory-management',
        data: { breadcrumb: 'Αποθήκη' },
        loadChildren: () => import('./features/inventory-management/inventory-management.module').then((m) => m.InventoryManagementModule),
      },
      {
        path: 'inventory-updates',
        data: { breadcrumb: 'Ενημερώσεις Αποθήκης' },
        loadChildren: () => import('./features/inventory-update/inventory-update.module').then((m) => m.InventoryUpdateModule),
      },
      {
        path: 'employee',
        data: { breadcrumb: 'Εργαζόμενος' },
        loadChildren: () => import('./features/employee-management/employee-management.module').then((m) => m.EmployeeManagementModule),
      },
      {
        path: 'employee-schedule',
        data: { breadcrumb: 'Πρόγραμμα Εργαζομένων' },
        loadChildren: () => import('./features/employee-schedule/employee-schedule.module').then((m) => m.EmployeeScheduleModule),
      },
      {
        path: 'shift-management',
        data: { breadcrumb: 'Εκκίνηση Βάρδιας' },
        loadChildren: () => import('./features/shift-management/shift-management.module').then((m) => m.ShiftManagementModule),
      },
      {
        path: 'barcode',
        data: { breadcrumb: 'Barcode Scanner' },
        loadChildren: () => import('./features/barcode/barcode.module').then((m) => m.BarcodeModule),
      },
      {
        path: 'ticket-categories',
        data: { breadcrumb: 'Ticket Categories' },
        loadChildren: () => import('./features/ticket-category/ticket-category.module').then((m) => m.TicketCategoryModule),
      },
      {
        path: 'transactions',
        data: { breadcrumb: 'Συναλλαγές' },
        loadChildren: () => import('./features/transactions/transactions.module').then((m) => m.TransactionsModule),
      },
      {
        path: 'subscription',
        data: { breadcrumb: 'Συνδρομές' },
        loadChildren: () => import('./features/subscription/subscription.module').then((m) => m.SubscriptionModule),
      },
    ],
  },
  {
    path: 'wizard',
    component: WizardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'start-shift',
        loadChildren: () => import('./features/shift-management/start-shift-wizard-v2/start-shift-wizard-v2.module').then((m) => m.StartShiftWizardV2Module),
      },
      {
        path: 'stop-shift',
        loadChildren: () =>
          import('./features/shift-management/stop-shift-wizard/stop-shift-wizard.routes').then((m) => m.STOP_SHIFT_WIZARD_ROUTES),
      },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    data: { breadcrumb: 'auth' },
    children: [
      {
        path: '',
        loadChildren: () => import('./features/authentication/authentication.module').then((m) => m.AuthenticationModule),
      },
    ],
  },
  { path: 'notfound', loadChildren: () => import('./demo/components/notfound/notfound.module').then((m) => m.NotfoundModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
